export const initializeSchemaFields = (
  derived: SchemaResponse
): SchemaFields => {
  return derived.schema.attributes.reduce(
    (schemaFields: SchemaFields, attribute) => {
      schemaFields[attribute.name] = {
        mapped: true,
        dataType: attribute.dataType,
        toName: ''
      };
      return schemaFields;
    },
    {}
  );
};

export const getInitialXyFields = (fields: string[]) => ({
  x: fields.find(field => /^(lon|lng|long|longitude|x)$/i.test(field)),
  y: fields.find(field => /^(lat|latitude|y)$/i.test(field))
});
